import React from 'react';
import { Document, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import { NegocioConfig } from "../../../configuracion/Empresa";
import { formatoMoneda } from "../../../configuracion/validaciones";

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 9,
        paddingTop: 30,
        paddingBottom: 40,
        paddingHorizontal: 35,
        backgroundColor: '#ffffff',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        borderBottomWidth: 1.5,
        borderBottomColor: '#1467cd',
        paddingBottom: 10,
        marginBottom: 10,
    },
    companyInfoLeft: {
        flexGrow: 1,
        maxWidth: '75%',
    },
    companyName: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 15,
        color: '#1467cd',
        marginBottom: 2,
    },
    companyDetail: {
        fontSize: 8.5,
        color: '#444',
        marginBottom: 1.5,
    },
    logo: {
        width: 75,
        height: 75,
        objectFit: 'contain',
        alignSelf: 'flex-end',
    },
    titleBlock: {
        textAlign: 'center',
        marginVertical: 6,
    },
    title: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 13,
        color: '#222',
        textTransform: 'uppercase',
        letterSpacing: 0.5,
    },
    subTitle: {
        fontSize: 9.5,
        color: '#555',
        marginTop: 2,
    },
    metaBox: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#f8fafc',
        borderWidth: 1,
        borderColor: '#e2e8f0',
        borderRadius: 4,
        padding: 6,
        marginBottom: 10,
    },
    metaCol: {
        flex: 1,
    },
    metaLabel: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 8,
        color: '#64748b',
        textTransform: 'uppercase',
    },
    metaValue: {
        fontSize: 8.5,
        color: '#1e293b',
        marginTop: 1,
    },
    kpiRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 6,
        marginBottom: 12,
    },
    kpiCard: {
        flex: 1,
        backgroundColor: '#f8fafc',
        borderWidth: 1,
        borderColor: '#cbd5e1',
        borderRadius: 4,
        padding: 6,
        borderLeftWidth: 4,
    },
    kpiCardBlue: { borderLeftColor: '#1467cd' },
    kpiCardGreen: { borderLeftColor: '#10b981' },
    kpiCardCyan: { borderLeftColor: '#0ea5e9' },
    kpiCardRed: { borderLeftColor: '#ef4444' },
    kpiTitle: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 7.5,
        color: '#475569',
        textTransform: 'uppercase',
    },
    kpiValue: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 11,
        color: '#0f172a',
        marginTop: 2,
    },
    kpiSubtext: {
        fontSize: 7.5,
        color: '#64748b',
        marginTop: 1,
    },
    sectionTitle: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 9.5,
        backgroundColor: '#f1f5f9',
        borderLeftWidth: 3,
        borderLeftColor: '#1467cd',
        paddingVertical: 3,
        paddingHorizontal: 6,
        marginTop: 8,
        marginBottom: 4,
        color: '#1e293b',
        textTransform: 'uppercase',
    },
    table: {
        width: '100%',
        marginBottom: 10,
        borderWidth: 1,
        borderColor: '#e2e8f0',
        borderRadius: 3,
        overflow: 'hidden',
    },
    tableHeaderRow: {
        flexDirection: 'row',
        backgroundColor: '#e2e8f0',
        paddingVertical: 4,
        paddingHorizontal: 6,
        borderBottomWidth: 1,
        borderBottomColor: '#cbd5e1',
    },
    tableHeaderCell: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 8,
        color: '#334155',
    },
    tableRow: {
        flexDirection: 'row',
        paddingVertical: 3.5,
        paddingHorizontal: 6,
        borderBottomWidth: 0.5,
        borderBottomColor: '#f1f5f9',
    },
    tableRowEven: {
        backgroundColor: '#f8fafc',
    },
    tableCell: {
        fontSize: 8,
        color: '#1e293b',
    },
    tableTotalRow: {
        flexDirection: 'row',
        backgroundColor: '#f1f5f9',
        paddingVertical: 4,
        paddingHorizontal: 6,
        borderTopWidth: 1,
        borderTopColor: '#94a3b8',
    },
    tableTotalCell: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 8.5,
        color: '#0f172a',
    },
    textRight: {
        textAlign: 'right',
    },
    textCenter: {
        textAlign: 'center',
    },
    badgeRed: {
        color: '#dc2626',
        fontFamily: 'Helvetica-Bold',
    },
    badgeYellow: {
        color: '#d97706',
        fontFamily: 'Helvetica-Bold',
    },
    badgeBlue: {
        color: '#2563eb',
        fontFamily: 'Helvetica-Bold',
    },
    emptyNotice: {
        padding: 8,
        textAlign: 'center',
        color: '#64748b',
        fontSize: 8.5,
        fontStyle: 'italic',
    },
    signatureBlock: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginTop: 25,
        marginBottom: 10,
    },
    signatureItem: {
        width: 170,
        textAlign: 'center',
    },
    signatureLine: {
        borderTopWidth: 1,
        borderTopColor: '#475569',
        marginBottom: 3,
    },
    signatureName: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 8.5,
        color: '#334155',
    },
    signatureTitle: {
        fontSize: 7.5,
        color: '#64748b',
    },
    footer: {
        position: 'absolute',
        bottom: 15,
        left: 35,
        right: 35,
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderTopWidth: 0.5,
        borderTopColor: '#cbd5e1',
        paddingTop: 4,
    },
    footerText: {
        fontSize: 7,
        color: '#94a3b8',
    },
});

const ReporteAnalisisVentas = ({
    metricas = {},
    chartPagos = null,
    pagosRaw = [],
    chartEvolucion = null,
    evolucionRaw = [],
    datosMora = null,
    periodoLabel = "Período actual",
    rangoFechas = null,
    usuario = null
}) => {
    const totalNeto = parseFloat(metricas?.totalNeto || 0);
    const montoContado = parseFloat(metricas?.montoContado || 0);
    const montoCredito = parseFloat(metricas?.montoCredito || 0);
    const pctContado = metricas?.porcentajeContado || '0';
    const pctCredito = metricas?.porcentajeCredito || '0';
    const tasaMora = metricas?.tasaMora || '0';
    const totalVencido = parseFloat(datosMora?.totalVencido || 0);

    // Métodos de pago
    const listaPagos = (pagosRaw && pagosRaw.length > 0)
        ? pagosRaw
        : (chartPagos?.labels || []).map((lbl, idx) => ({
            metodo: lbl,
            total: chartPagos?.data?.[idx] || 0
        }));

    const totalMetodosPago = listaPagos.reduce((acc, p) => acc + parseFloat(p.total || 0), 0);

    // Evolución diaria
    const listaEvolucion = (evolucionRaw && evolucionRaw.length > 0)
        ? evolucionRaw
        : (chartEvolucion?.labels || []).map((lbl, idx) => ({
            fecha: lbl,
            montoContado: chartEvolucion?.datasets?.[0]?.data?.[idx] || 0,
            montoCredito: chartEvolucion?.datasets?.[1]?.data?.[idx] || 0,
        }));

    const sumaEvolContado = listaEvolucion.reduce((acc, d) => acc + parseFloat(d.montoContado || 0), 0);
    const sumaEvolCredito = listaEvolucion.reduce((acc, d) => acc + parseFloat(d.montoCredito || 0), 0);
    const sumaEvolTotal = sumaEvolContado + sumaEvolCredito;

    // Detalle mora
    const detalleMora = datosMora?.detalle || [];

    const fechaDesde = rangoFechas?.fechaInicioFormato || (rangoFechas?.fechaInicio ? moment(rangoFechas.fechaInicio).format('DD/MM/YYYY') : '—');
    const fechaHasta = rangoFechas?.fechaFinFormato || (rangoFechas?.fechaFin ? moment(rangoFechas.fechaFin).format('DD/MM/YYYY') : '—');

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {/* 1. Encabezado Institucional */}
                <View style={styles.header}>
                    <View style={styles.companyInfoLeft}>
                        <Text style={styles.companyName}>{NegocioConfig.nombre}</Text>
                        <Text style={styles.companyDetail}>RTN: {NegocioConfig.rtn}</Text>
                        <Text style={styles.companyDetail}>{NegocioConfig.direccion}</Text>
                        <Text style={styles.companyDetail}>Tel: {NegocioConfig.telefono} | Correo: {NegocioConfig.correo}</Text>
                    </View>
                    <Image src={NegocioConfig.logo} style={styles.logo} />
                </View>

                {/* 2. Título y Rango */}
                <View style={styles.titleBlock}>
                    <Text style={styles.title}>Reporte de Análisis de Ventas</Text>
                    <Text style={styles.subTitle}>Período: {periodoLabel}</Text>
                </View>

                {/* 3. Metadatos */}
                <View style={styles.metaBox}>
                    <View style={styles.metaCol}>
                        <Text style={styles.metaLabel}>Rango Evaluado</Text>
                        <Text style={styles.metaValue}>{fechaDesde} al {fechaHasta}</Text>
                    </View>
                    <View style={styles.metaCol}>
                        <Text style={styles.metaLabel}>Fecha de Emisión</Text>
                        <Text style={styles.metaValue}>{moment().format('DD/MM/YYYY hh:mm A')}</Text>
                    </View>
                    <View style={styles.metaCol}>
                        <Text style={styles.metaLabel}>Generado Por</Text>
                        <Text style={styles.metaValue}>{usuario?.nombre || usuario?.nombreCompleto || 'Usuario del Sistema'}</Text>
                    </View>
                </View>

                {/* 4. Cajas de Indicadores (KPIs) */}
                <View style={styles.kpiRow}>
                    <View style={[styles.kpiCard, styles.kpiCardBlue]}>
                        <Text style={styles.kpiTitle}>Total Ventas</Text>
                        <Text style={styles.kpiValue}>{formatoMoneda(totalNeto)}</Text>
                        <Text style={styles.kpiSubtext}>Facturación neta total</Text>
                    </View>

                    <View style={[styles.kpiCard, styles.kpiCardGreen]}>
                        <Text style={styles.kpiTitle}>Ventas Contado</Text>
                        <Text style={styles.kpiValue}>{formatoMoneda(montoContado)}</Text>
                        <Text style={styles.kpiSubtext}>{pctContado}% de participación</Text>
                    </View>

                    <View style={[styles.kpiCard, styles.kpiCardCyan]}>
                        <Text style={styles.kpiTitle}>Ventas Crédito</Text>
                        <Text style={styles.kpiValue}>{formatoMoneda(montoCredito)}</Text>
                        <Text style={styles.kpiSubtext}>{pctCredito}% de participación</Text>
                    </View>

                    <View style={[styles.kpiCard, styles.kpiCardRed]}>
                        <Text style={styles.kpiTitle}>Tasa de Mora</Text>
                        <Text style={styles.kpiValue}>{tasaMora}%</Text>
                        <Text style={styles.kpiSubtext}>Saldo: {formatoMoneda(totalVencido)}</Text>
                    </View>
                </View>

                {/* 5. Tabla: Distribución por Métodos de Pago */}
                <Text style={styles.sectionTitle}>1. Distribución por Métodos de Pago</Text>
                <View style={styles.table}>
                    <View style={styles.tableHeaderRow}>
                        <Text style={[styles.tableHeaderCell, { width: '50%' }]}>Método de Pago</Text>
                        <Text style={[styles.tableHeaderCell, styles.textRight, { width: '30%' }]}>Total Recibido (L)</Text>
                        <Text style={[styles.tableHeaderCell, styles.textRight, { width: '20%' }]}>% Participación</Text>
                    </View>
                    {listaPagos.map((p, idx) => {
                        const montoP = parseFloat(p.total || 0);
                        const pctP = totalMetodosPago > 0 ? ((montoP / totalMetodosPago) * 100).toFixed(1) : '0';
                        return (
                            <View key={idx} style={[styles.tableRow, idx % 2 === 1 ? styles.tableRowEven : {}]}>
                                <Text style={[styles.tableCell, { width: '50%' }]}>{p.metodo || 'No especificado'}</Text>
                                <Text style={[styles.tableCell, styles.textRight, { width: '30%' }]}>{formatoMoneda(montoP)}</Text>
                                <Text style={[styles.tableCell, styles.textRight, { width: '20%' }]}>{pctP}%</Text>
                            </View>
                        );
                    })}
                    <View style={styles.tableTotalRow}>
                        <Text style={[styles.tableTotalCell, { width: '50%' }]}>Total Pagos Registrados</Text>
                        <Text style={[styles.tableTotalCell, styles.textRight, { width: '30%' }]}>{formatoMoneda(totalMetodosPago)}</Text>
                        <Text style={[styles.tableTotalCell, styles.textRight, { width: '20%' }]}>100.0%</Text>
                    </View>
                </View>

                {/* 6. Tabla: Evolución Diaria (Contado vs Crédito) */}
                <Text style={styles.sectionTitle}>2. Evolución Periódica de Ventas</Text>
                <View style={styles.table}>
                    <View style={styles.tableHeaderRow}>
                        <Text style={[styles.tableHeaderCell, { width: '22%' }]}>Fecha / Día</Text>
                        <Text style={[styles.tableHeaderCell, styles.textRight, { width: '26%' }]}>Contado (L)</Text>
                        <Text style={[styles.tableHeaderCell, styles.textRight, { width: '26%' }]}>Crédito (L)</Text>
                        <Text style={[styles.tableHeaderCell, styles.textRight, { width: '26%' }]}>Total Día (L)</Text>
                    </View>
                    {listaEvolucion.length > 0 ? (
                        listaEvolucion.map((item, idx) => {
                            const c = parseFloat(item.montoContado || 0);
                            const cr = parseFloat(item.montoCredito || 0);
                            const tot = c + cr;
                            const fechaLabel = item.fecha ? (moment(item.fecha).isValid() ? moment(item.fecha).format('DD/MM/YYYY') : item.fecha) : `Día ${idx + 1}`;
                            return (
                                <View key={idx} style={[styles.tableRow, idx % 2 === 1 ? styles.tableRowEven : {}]}>
                                    <Text style={[styles.tableCell, { width: '22%' }]}>{fechaLabel}</Text>
                                    <Text style={[styles.tableCell, styles.textRight, { width: '26%' }]}>{formatoMoneda(c)}</Text>
                                    <Text style={[styles.tableCell, styles.textRight, { width: '26%' }]}>{formatoMoneda(cr)}</Text>
                                    <Text style={[styles.tableCell, styles.textRight, { width: '26%', fontFamily: 'Helvetica-Bold' }]}>{formatoMoneda(tot)}</Text>
                                </View>
                            );
                        })
                    ) : (
                        <Text style={styles.emptyNotice}>No hay datos de evolución diaria para este período.</Text>
                    )}
                    {listaEvolucion.length > 0 && (
                        <View style={styles.tableTotalRow}>
                            <Text style={[styles.tableTotalCell, { width: '22%' }]}>Totales</Text>
                            <Text style={[styles.tableTotalCell, styles.textRight, { width: '26%' }]}>{formatoMoneda(sumaEvolContado)}</Text>
                            <Text style={[styles.tableTotalCell, styles.textRight, { width: '26%' }]}>{formatoMoneda(sumaEvolCredito)}</Text>
                            <Text style={[styles.tableTotalCell, styles.textRight, { width: '26%' }]}>{formatoMoneda(sumaEvolTotal)}</Text>
                        </View>
                    )}
                </View>

                {/* 7. Tabla: Clientes con Créditos Vencidos (Mora) */}
                <Text style={styles.sectionTitle}>3. Clientes con Créditos Vencidos (Mora)</Text>
                <View style={styles.table}>
                    <View style={styles.tableHeaderRow}>
                        <Text style={[styles.tableHeaderCell, { width: '12%' }]}>ID</Text>
                        <Text style={[styles.tableHeaderCell, { width: '38%' }]}>Cliente / Empresa</Text>
                        <Text style={[styles.tableHeaderCell, styles.textCenter, { width: '16%' }]}>Vencimiento</Text>
                        <Text style={[styles.tableHeaderCell, styles.textCenter, { width: '14%' }]}>Días Mora</Text>
                        <Text style={[styles.tableHeaderCell, styles.textRight, { width: '20%' }]}>Saldo (L)</Text>
                    </View>
                    {detalleMora.length > 0 ? (
                        detalleMora.map((item, idx) => {
                            const dias = parseInt(item.diasMora || 0, 10);
                            let badgeStyle = styles.badgeBlue;
                            if (dias > 60) badgeStyle = styles.badgeRed;
                            else if (dias >= 30) badgeStyle = styles.badgeYellow;

                            const fVenc = item.fechaVencimiento ? moment(item.fechaVencimiento).format('DD/MM/YYYY') : '—';
                            const empresa = item.clienteEmpresa ? item.clienteEmpresa.replace(/<[^>]*>?/gm, '') : '';
                            const clienteNombre = item.clienteNombre || 'Sin cliente';
                            const clienteTexto = empresa ? `${empresa} (${clienteNombre})` : clienteNombre;

                            return (
                                <View key={idx} style={[styles.tableRow, idx % 2 === 1 ? styles.tableRowEven : {}]}>
                                    <Text style={[styles.tableCell, { width: '12%' }]}>#{item.creditoId || item.id || '—'}</Text>
                                    <Text style={[styles.tableCell, { width: '38%' }]}>{clienteTexto}</Text>
                                    <Text style={[styles.tableCell, styles.textCenter, { width: '16%' }]}>{fVenc}</Text>
                                    <Text style={[styles.tableCell, styles.textCenter, badgeStyle, { width: '14%' }]}>{dias} días</Text>
                                    <Text style={[styles.tableCell, styles.textRight, { width: '20%', fontFamily: 'Helvetica-Bold' }]}>{formatoMoneda(item.saldo || 0)}</Text>
                                </View>
                            );
                        })
                    ) : (
                        <Text style={styles.emptyNotice}>No se registran créditos en mora para el período analizado.</Text>
                    )}
                    {detalleMora.length > 0 && (
                        <View style={styles.tableTotalRow}>
                            <Text style={[styles.tableTotalCell, { width: '80%' }]}>Total Saldo en Mora</Text>
                            <Text style={[styles.tableTotalCell, styles.textRight, { width: '20%' }]}>{formatoMoneda(totalVencido)}</Text>
                        </View>
                    )}
                </View>

                {/* 8. Bloque de Firmas */}
                <View style={styles.signatureBlock}>
                    <View style={styles.signatureItem}>
                        <View style={styles.signatureLine} />
                        <Text style={styles.signatureName}>Elaborado Por</Text>
                        <Text style={styles.signatureTitle}>{usuario?.nombre || 'Responsable de Ventas'}</Text>
                    </View>
                    <View style={styles.signatureItem}>
                        <View style={styles.signatureLine} />
                        <Text style={styles.signatureName}>Revisado y Aprobado</Text>
                        <Text style={styles.signatureTitle}>Gerencia / Administración</Text>
                    </View>
                </View>

                {/* 9. Pie de página fijo */}
                <View style={styles.footer} fixed>
                    <Text style={styles.footerText}>
                        {NegocioConfig.nombre} — Sistema SIGVEM | Reporte Oficial de Análisis
                    </Text>
                    <Text
                        style={styles.footerText}
                        render={({ pageNumber, totalPages }) => `Página ${pageNumber} de ${totalPages}`}
                    />
                </View>
            </Page>
        </Document>
    );
};

export default ReporteAnalisisVentas;
